import React, {
    useState,
    useEffect,
    useContext
} from 'react';
import { WinnersGameItem } from '../winnersGameItem/WinnersGameItem';
import { GameImprovementsTitle } from '../GameImprovementsTitle/GameImprovmentsTitle';
import {
    AsgAppContext,
    AsgFwContext
} from '../../contexts';
import './WinnersGame.css';
import { ArrayUtilService } from '../../../../shared/src/services/util/array-util.service';
/**
 * Parent component for show winners Games rendered on game page
 * @return {JSX.Element}
 * @constructor
 */
export const WinnersGame = ({ gamesListItem, winnersOpenStatus, changeStatus, changeMobilePanelOpenStatus }) => {
    const AsgFW = useContext(AsgFwContext);
    const AsgApp = useContext(AsgAppContext);

    const [winnersList, setWinnersList] = useState([]);

    useEffect(() => {
        if (winnersList && !winnersOpenStatus) {
            AsgFW.setGetWinnersData(getWinners);
        }
    }, [winnersOpenStatus]);

    const getWinners = (winners) => {
        if (winners) {
            setWinnersList(ArrayUtilService.getRandomElements(filterGames(winners), 4));
        } else {
            setWinnersList([]);
        }
    };

    const filterGames = (winnersGameList) => {
        const filteredList = [];
        for (var i in gamesListItem) {
            const val = gamesListItem[i];
            // eslint-disable-next-line max-len
            const gameData = winnersGameList.find(item => item.gameName.toLowerCase().trim() === Tools.replaceAll(val.name.toLowerCase().trim(),'\'', ''));
            if (gameData) {
                gameData.img = val.images.default;
                gameData.imgWebp = val.images.webp;
                gameData.id = val.id;
                filteredList.push(gameData);
            }
        }
        return filteredList;
    };

    const handleWinnersGameOpenStatus = (data) => {
        if (data) {
            AsgApp.GAeventTracking('winners - ' + (AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop')
                + ' game page', 'winners - ' + (AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop')
                + ' game page click', data.gameName);
        }
        changeStatus(!winnersOpenStatus);
        if (AsgFW.isMobilePamPlatform()) {
            changeMobilePanelOpenStatus(false);
        }
    };

    return (
        <div className={`winners-game-component__btn-wrapper ${winnersOpenStatus ? ' active' : ''}`}>
            <div
                className="winners-game-component__btn cta-common"
                onClick={changeStatus}
            > </div>
            {winnersOpenStatus ?
                <div className="winners-game-result-wrap">
                    <GameImprovementsTitle title="winners" />
                    <div className="winners-game-component__result">
                        {
                            winnersList.map((gameItem, key) => (
                                <WinnersGameItem
                                    onOpenGame={(item) => {
                                        handleWinnersGameOpenStatus(item);
                                    }}
                                    key={key}
                                    data={gameItem}
                                />
                            ))
                        }
                    </div>
                </div>
                : null}
        </div>
    );
};
